import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FiBell } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";
import {
  notificationSchoolMockData,
  notificationStudentMockData,
} from "src/services/notification-mock-data/notification-mock-data";

function NotificationComponent() {
  const [showNotificationDropdown, setNotificationDropdown] =
    useState<boolean>(false);
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();

  const dummyNotificationData =
    localStorage.getItem("role") === "student"
      ? notificationStudentMockData
      : notificationSchoolMockData;

  return (
    <div
      className="relative cursor-pointer"
      onClick={() => {
        setNotificationDropdown(!showNotificationDropdown);
      }}
    >
      <FiBell size={24} className="text-zinc700" />
      <div className="absolute flex -top-1 -right-1 rounded-full h-4 w-4 bg-tart-500 justify-center items-center text-white text-xs">
        6
      </div>{" "}
      {showNotificationDropdown ? (
        <div
          className={`${
            i18n.language === "ar"
              ? "-right-[90px] mobile:-right-[115px]"
              : "-left-[90px] mobile:-left-[90px]"
          } absolute top-11 pt-2 px-3 h-44 w-72 bg-AliceBlue rounded drop-shadow-[0_0px_15px_rgba(0,0,0,0.1)] overflow-y-auto`}
        >
          {dummyNotificationData.slice(0, 3).map((item, index) => (
            <div
              className="flex flex-col border-b border-[#CBD5E1] pb-2 mt-1"
              key={index}
            >
              <div className="flex flex-row justify-between">
                {item.read ? (
                  <div className="rounded-full bg-transparent h-2.5 w-2.5"></div>
                ) : (
                  <div className="rounded-full bg-secondary-50 h-2.5 w-2.5"></div>
                )}
                <div dir="ltr" className="font-ar text-zinc400 text-xs pt-2">
                  {item.time}
                </div>
              </div>
              <div className="font-ar text-M3 text-base">
                {i18n.language === "ar" ? item.title : item.titleEn}
              </div>
              <div className="font-ar text-zinc400 text-xs pt-2">
                {i18n.language === "ar" ? item.description : item.descriptionEn}
              </div>
            </div>
          ))}
          {dummyNotificationData.length > 3 ? (
            <div
              className="flex items-center text-mint-500 font-ar text-[8px] h-7"
              onClick={() => navigate(appRoutesObj.getNotificationPagePath())}
            >
              {t("notification.component.showMore")}
            </div>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default NotificationComponent;
